import { NotificationService } from "../notification/notification.service";

export const createFormModalMixin = () => {
  return {
    data: function () {
      return {
        textFieldConfig: {
          height: 42,
          showEditIconOnHover: false,
          box: true,
          showValidationIcons: false
        },
      }
    },
    computed: {
      mode: function () {
        return this.$route.query.mode;
      },
      isEditMode: function () {
        return this.mode == 'edit';
      },
      isAddMode: function () {
        return this.mode == 'add';
      },
      title: function () {
        if (this.isEditMode) {
          return 'Edit';
        } else if (this.isAddMode) {
          return 'Add';
        } else {
          return '';
        }
      }
    },
    methods: {
      onCancel: function () {
        this.$emit('cancelled', true);
      },
    }
  }
}


export const createFormItemMixin = ({
  primary_key,
  itemKey,
  detailsHttpReq,
  addHttpReq,
  submitItemGetter = '',
  processAddHttpResMethod = '',
}) => {
  return {
    mounted: async function () {
      if (this.isEditMode) {
        if (!this[primary_key]) {
          NotificationService.showNotification({
            text: `Pass a valid ${primary_key} as query param`,
            timeout: 5000,
            type: 'error',
          });
        }
        if (detailsHttpReq) {
          const itemDetails = await detailsHttpReq({
            [primary_key]: this[primary_key]  //licence_line_id:licence_lince_id
            //...ObjectParama { licence_line_id ,licence_id}
          });
          console.log({"itemDetails": itemDetails});
          this['details'] = itemDetails?.data;
          this[itemKey] = itemDetails?.data[itemKey];
        }

        if (!this[itemKey]) {
          NotificationService.showNotification({
            text: `Error getting ${itemKey} !`,
            timeout: 5000,
            type: 'error',
          });
          this.onCancel();
        }
        // console.log(`Log: this.${itemKey}`, this[itemKey]);
      } else {
        this[itemKey] = this[`get_${itemKey}`]();

        if (addHttpReq) {
          const itemDetails = await addHttpReq();
          this['details'] = itemDetails?.data;
          console.log(processAddHttpResMethod);
          if (processAddHttpResMethod) {
            this[processAddHttpResMethod]();
          }
        }

      }
    },
    data: function () {
      return {
        details: null,

        submitted: false,
        [itemKey]: this[`get_${itemKey}`](),
      }
    },
    computed: {

      [primary_key]: function () {
        return this.$route.query[primary_key];
      },
      loadingFlag: function () {
        if (this.isEditMode) {
          return !this[itemKey][primary_key];
        } else {
          return this.submitted;
        }
      },
    },
    methods: {
      onTextFieldValueChange: function(id, value) {
        this[itemKey][id] = value;
      },
      onDropdownChange: function(name, value) {
        this[itemKey][name] = value.value;
      },
      onCheckboxChange: function(name, event) {
        const value = event.target.checked ? '1' : '0';
        this[itemKey][name] = value;
      },
      onFormSubmit: function() {
        this.submitted = true;
        
        if (submitItemGetter) {
          this.$emit('done', {
            mode: this.mode,
            [itemKey]: this[submitItemGetter]()
          });
        } else {
          this.$emit('done', {
            mode: this.mode,
            [itemKey]: this[itemKey]
          });
        }
      },
    }
  }
}